import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { ArrowForwardIosRoundedIcon } from "../legacy-ui/icons";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { ButtonBase } from "../legacy-ui/materialCompat";
import smoothScroll from "../../utils/animateScroll";

const SCROLL_CONTAINER_SELECTOR = [
  ".legacy-paged-scroll",
  ".legacy-route-scroll",
  ".legacy-detail-scroll",
  ".legacy-profile-list-scroll",
  ".legacy-parent-scroll",
  ".legacy-parent-category-scroll",
  ".legacy-anavatan-scroll-rows",
  ".legacy-anavatan-grid-scroll",
  ".legacy-search-scroll",
].join(",");

function nodeMatches(node, selector) {
  var matches =
    node &&
    (node.matches ||
      node.msMatchesSelector ||
      node.webkitMatchesSelector ||
      node.mozMatchesSelector);

  return !!(matches && matches.call(node, selector));
}

function findScrollContainer(node) {
  var current = node;

  while (current && current !== document.body && current !== document.documentElement) {
    if (nodeMatches(current, SCROLL_CONTAINER_SELECTOR)) return current;
    current = current.parentNode;
  }

  return null;
}

function scrollNearestRouteToTop(node) {
  var scrollNode = findScrollContainer(node);

  if (scrollNode) {
    smoothScroll({ current: scrollNode }, 0, 320);
    return;
  }

  if (typeof window !== "undefined" && window.scrollTo) {
    window.scrollTo(0, 0);
  }
}

const BackBarButton = ({ invertedIcon }) => {
  const navigate = useNavigate();

  const { focused, ref } = useFocusable({
    focusKey: "backBarButton",
    onEnterPress: () => navigate(-1),
  });

  useEffect(() => {
    if (focused) {
      ref?.current?.dispatchEvent(
        new MouseEvent("mouseover", {
          view: window,
          bubbles: true,
          cancelable: true,
        }),
      );
      scrollNearestRouteToTop(ref.current);
    }
  }, [focused, ref]);

  return (
    <ButtonBase
      type="button"
      className="dark !bg-black/50 !backdrop-blur-xl !border-1 !border-zinc-700 !rounded-2xl !text-white !m-5"
      onClick={() => navigate(-1)}
      ref={ref}
      style={{
        boxShadow: focused
          ? "inset 0 0 0 4px #F5F5F5"
          : "inset 0 0 0 4px transparent",
        fontSize: 25,
        padding: "1.5rem 2rem",
      }}
    >
      {invertedIcon ? (
        <ArrowForwardIosRoundedIcon
          fontSize="lg"
          sx={{
            transform: "scaleX(-1)",
          }}
        />
      ) : (
        <ArrowForwardIosRoundedIcon fontSize="lg" />
      )}
      بازگشت
    </ButtonBase>
  );
};

export const BackBarButtonMini = ({ invertedIcon }) => {
  const navigate = useNavigate();

  const { focused, ref } = useFocusable({
    focusKey: "backBarButton-mini",
    onEnterPress: () => navigate(-1),
  });

  useEffect(() => {
    if (focused) {
      ref?.current?.dispatchEvent(
        new MouseEvent("mouseover", {
          view: window,
          bubbles: true,
          cancelable: true,
        }),
      );
      scrollNearestRouteToTop(ref.current);
    }
  }, [focused, ref]);

  return (
    <button
      type="button"
      className={"legacy-back-mini-button" + (focused ? " is-focused" : "")}
      onClick={() => navigate(-1)}
      ref={ref}
      style={{
        fontSize: 30,
      }}
    >
      {invertedIcon ? (
        <ArrowForwardIosRoundedIcon
          fontSize="lg"
          color="whitesmoke"
          sx={{
            transform: "scaleX(-1)",
          }}
        />
      ) : (
        <ArrowForwardIosRoundedIcon color="whitesmoke" fontSize="lg" />
      )}
    </button>
  );
};

export default BackBarButton;
